
(function(template){
define('vue!app/views/vue/components/packageDivComponent/packageScheduleComponent/container',[
  "Vue",
  "moment",
  "vue!./DateTimeSelection",
  "vuex",
  "helpers",
  "vuecal",
  "vue!../../../basicComponents/popup",
  "underscore",
  "vue_scrollbar",
  "vue!./timePicker", "vue_sticky", "vue!app/views/vue/components/cartComponent/cartBody/scheduleButtonComponent","vue!./servicePref",'jquery',"vue!app/views/vue/components/cartComponent/cartBody/bookingIndicatorComponent",
  "vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/GroupMembersOtb"
], function (
  Vue,
  moment,
  DateTimeSelection,
  vuex,
  helpers,
  vuecal,
  popup, _, vue_scrollbar, timePicker, vue_sticky, schedulebtn,servicePref, $,bookingIndicator,GroupMembersOtb
) {

  Vue.use(vue_sticky)

  return {
    template: template,
    name: "scheduleComponent",
    props: ['service'],
    data: function () {
      return {
        currentUser: 0,
        togglePref: false,
		    alreadyAssignedStaff: {},
        activeSpaItemId: "",
        userList: [],
        SpaAvailabilities: {},
        AvailableStaffList: {},
        activePackageSpaItemId: "",
        schedulingPackage: false,
        packageBookingInfo: {updatedInfo:[],originalInfo:[]},
        autoAssignedStaffPerGuestInBookForAll: {},
        genders: [
        {
          name: "noPreference",
          prefix: "P",
          show:true
        },
        {
          name: "male",
          prefix: "M",
          show:true
        }, {
          name: "female",
          prefix: "F",
          show:true
        }],
        Genders: {},
        sticky_reserve_btn: false,
        sticky_schedule_update_Btn: false,
        showStaffDropDown:false
      };
    },
    computed: _.extend(
      vuex.mapState([
        "users",
        'bookingProgressPerUser',
        "desktopMode",
        "currentlyEditingService",
        "isFetching",
        "activePackageItem",
        "status",
        "activeUser",
        "selectedServices",
        "afterDeleteData",
        "usersWithIds", "HiddenReservedPackageItems", "ActiveUserCalenderEvents", "selectedDateOnDateBar", "bookingButtonText", "bookForAllGuestCheckBox", "errorMessage", 'loggedInUser', 'dataForBookingService', 'activeStep', 'bookFromCart','detectedChanges', 'selectedDateTimeOnTimePicker','selectedTimeOnTimePicker','editingFolioItemId', 'OTBactive', 'firstTimeOtbBook', 'lastFetchDate', 'noAvails'
      ]), {
        dynamicRestriction_timePickerErrorMessage: {
          get: function () {
            if(app.commonViewHelper.active_ttb_effects.spaTimePickerErrorMessage) {
              var spaTimePickerErrorMessageRes = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.spaTimePickerErrorMessage);                    
                  if(spaTimePickerErrorMessageRes.isActive){
                      return spaTimePickerErrorMessageRes.value;
                  } 
            }
          },
          cache: false
        },
        username: function(){
          return Object.keys(this.users)[this.activeUser];
        },
        serviceDetails: function(){
          return this.users[this.username][this.activeSpaItemId] || {};
        },
        serviceId: function() {
          return this.activeSpaItemId;
        },
        globalStatus: function () {
          return _.values(this.localStrings.stepper.body.schedule.status).slice(0, 5);
        },
        packageItemEditConfig: function () {
          return this.customization.configuration['editIndiviualPackageItem']
        },
        servicePrefConfig: function () {
          return this.customization.configuration['servicePrefBeforeTime']
        },
        bookingPackage: function () {
          return !!this.users[this.username][this.activeSpaItemId].package_item;
        },
        packageItems: function () {
          if (!this.bookingPackage) return [];
          return this.users[this.username][this.activeSpaItemId].package_item.PackageItems
            .PackageItem;
        },
        isServiceBooked: function () {
          return !!(this.users[this.username][this.activeSpaItemId]||{}).SpaFolioItemId
        },
        currentUserId: function () {
          return this.username
        },
        reservedTimesForUser: function () { //for avoiding conflic booking and to show on calander
          return this.$store.state.reservedTimes[this.currentUserId] || []
        },
        showMobileEditPackageItemBox: function () { //package info box on mobile 
          return this.isServiceBooked && !this.desktopMode && this.schedulingPackage && this.packageItemEditConfig
        },
        allserviceNotBooked: function () { // returns if there is atleast one service not booked
          vm = this
          return _.keys(this.users).some(function (user) {
            return _.values(vm.users[user]).some(function (item) {
              return !item.SpaFolioItemId
            });
          })
        },
        getActiveBookedTime: function () {
          if (this.username) {
            var service = this.serviceDetails;
            if (this.schedulingPackage && service.SpaFolioItemId) {
              return moment(service.package_item.PackageItems.PackageItem[this.activePackageItem].dateTime, "YYYY-MM-DDHHmmss").format("hh:mm a")
            } else return service.time || ""
          }
        },
        getActiveServiceDetails: function () { //if booking for all, then it return activeservice info for each guest
          var vm = this;
          if (vm.schedulingPackage) {
            var package_items = vm.packageItems
            _.each(package_items, function (item) {
              item.username = vm.username
            })
            return package_items
          } else {
            if (this.singleBookingMode && this.bookForAllGuestCheckBox) return this.getActiveServiceOfAllGuests()
            else {
              var singleItem = this.serviceDetails
              singleItem.SpaItemId = this.activeSpaItemId
              singleItem.username = this.username
              return [singleItem]
            }
          }
        },
        conditionsToBookorEdit: function () {
          var canBook = false
          var vm = this

          var staffRestrictionResult = StaffRequirmentLogic(vm)
          if (vm.isServiceBooked) {
            if (vm.detectedChanges.note || vm.detectedChanges.staff || vm.detectedChanges.time && staffRestrictionResult) canBook = true
          } else {
            if (vm.detectedChanges.time && staffRestrictionResult) canBook = true
          }

          function StaffRequirmentLogic(vm) {
            var noRestriction = true
            if (vm.staffPickRequired && vm.detectedChanges.staff) noRestriction = false
            return noRestriction
          }
          return canBook
        },
        forceGenderSelect: function () {
          var locationData = app.models.spaModel.getSelectedItem('spaLocations', {}),
              requireGender = locationData.ForceGenderSelect == "Y" && ( locationData.AllowGender == "Y" || locationData.AllowStaff == "Y")

            var staffSelected = this.users[this.username][this.activeSpaItemId].staffGenderOrId;

            if (requireGender && (!staffSelected || staffSelected === 'X')) {
           //   this.noAvailabilityErrorMsg =  this.localStrings.stepper.body.schedule.errors.selectStaffFirst
              console.log('locationData', locationData)
              return true;
            }
            return false
        },
        getActiveServiceBookedDateTime: function () {
          var service = this.serviceDetails;
            if (this.username && service.SpaFolioItemId) {
              if (this.schedulingPackage) {
                 return service.package_item.PackageItems.PackageItem[this.activePackageItem].dateTime
              } else return service.bookingDetails.StartDateTime
          } else return ''
        },
        getActiveServiceFormattedDate: function () {
          var serviceDate = this.serviceDetails.SpaFolioItemId ? this.serviceDetails.date : this.serviceDetails.preferedDate
          return serviceDate 
        },
        checkDayIsDisabled: function () {
          var vm = this;
          var disableDay = false;
          // Dynamic restriction code for spaPreventBookingDateRanges
          if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.spaPreventBookingDateRanges){
              var spaPreventBookingDateResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.spaPreventBookingDateRanges);
              if(spaPreventBookingDateResult.isActive && spaPreventBookingDateResult.value && spaPreventBookingDateResult.value.length){
                _.each(spaPreventBookingDateResult.value, function(timePeriod){
                  if(timePeriod.startDate <= vm.selectedDateOnDateBar && vm.selectedDateOnDateBar <= timePeriod.endDate){
                      disableDay = true;
                  }
                })
              }
          }
          return disableDay;
        },
      }),
    watch: {
      activeSpaItemId: function(){
        if(this.OTBactive && (this.$store.state.status != 'E') && this.customization.allowDurationGrouper){
          this.preFillDirtyData()
        }
      },
      service: function() {
        var vm = this;
        if(this.OTBactive && (this.$store.state.status != 'E') && this.customization.allowDurationGrouper){
          var userKeyIds = Object.keys(this.users[this.username]);
          this.activeSpaItemId = _.find(userKeyIds.reverse(), function(el){ return el.split("-")[0] == vm.service.SpaItemId})
          this.fetchAvailability();
        }
      },
      loggedInUser: function (val) {
        this.username = Object.keys(this.users)[this.activeUser];
        this.activeSpaItemId = Object.keys(this.users[this.username])[
          this.currentlyEditingService
        ];
      },
      bookFromCart: function (val) { // when user clicks reserve button on sidecart then trigger book service from this file
        if (val) this.bookService()
      },
      schedulingPackage: function (val) { //returns if currently actice service is package or not
        val && this.setActivePackageItemId();
        if (val && !this.isFetching) {
          this.$store.commit("setActivePackageItem", 0);
        }
      },
      afterDeleteData: {
        handler: function (arr) {
          if (arr.length == 0) return;
          console.log("71-1", 'called in bookcomponent')
          this.username = arr[0];
          this.activeSpaItemId = arr[1];
          this.schedulingPackage = !!this.users[this.username][this.activeSpaItemId].package_item;
          this.AdditionalLogicOnActivityChange();
        },
        deep: true
      },
      dataForBookingService: { //DIRTY DATA
        handler: function (obj) {
          console.log('myobj',obj);
          var vm = this
          vm.$store.commit('setDetectedChanges', {}) //reset changes status
          _.each(obj, function (val, key) {
            if (vm.schedulingPackage) {
              var package_items = vm.users[vm.username][vm.activeSpaItemId].package_item.PackageItems.PackageItem
              var targetedItemIndex = _.findIndex(package_items, function (item) {
                return item.SpaItemId == key
              })
              //note change detect
              if (((package_items[targetedItemIndex].note).trim()).localeCompare((vm.dataForBookingService[key].note).trim())) {
                vm.setDetectedChangeBoolean('note', true)
              }
              //staff change detect
              if (package_items[targetedItemIndex].staffGenderOrId != vm.dataForBookingService[key].staff) {
                vm.setDetectedChangeBoolean('staff', true)
              }
              // //time change detect , only look for active package item time(usually first service in package) when  cuz other item's time check doesnt matter especially when editing as availability for bookedtime may come back with different time and so we cant count them as detected time.In editing unless changing a time, datetime are not send for staff or note change so only check for first item
              if ( key == vm.activePackageSpaItemId &&package_items[targetedItemIndex].dateTime != vm.dataForBookingService[key].time) {
                vm.setDetectedChangeBoolean('time', true)
              }
            } else {
              console.log('burger',key,vm.dataForBookingService[key])
              var singleService = vm.users[vm.username][vm.activeSpaItemId]
              if (singleService.staffGenderOrId != vm.dataForBookingService[key].staff)
                vm.setDetectedChangeBoolean('staff', true)

              if (singleService.bookingDetails.StartDateTime != vm.dataForBookingService[key].time)
                vm.setDetectedChangeBoolean('time', true)

              if (((singleService.note).trim()).localeCompare((vm.dataForBookingService[key].note).trim()))
                vm.setDetectedChangeBoolean('note', true)
            }
          })
        },
        deep: true
      },
      activeUser: function (val) {
        console.log(" i was called in active user watch")
        this.schedulingPackage = false;
        this.$data.currentUser = val;
        // this.username = Object.keys(this.users)[this.currentUser];
        this.activeSpaItemId = Object.keys(this.users[this.username])[
          this.currentlyEditingService
        ];
        if (this.users[this.username][this.activeSpaItemId].package_item) this.schedulingPackage = true;
          this.AdditionalLogicOnActivityChange();
          this.preFillDirtyData() //to detect changes for note,time and staff. prefill them
      },
      currentlyEditingService: function (newValue, oldValue) {
        //if it runs when changes services. Note if chaging user, then active fnction will run instead of this
        this.$store.commit("setErrorMessage", "")
        this.activeSpaItemId = Object.keys(this.users[this.username])[parseInt(newValue)];
        this.schedulingPackage = !!this.users[this.username][this.activeSpaItemId].package_item
      //  this.AddHiddenPackageItemsToReserved() //this runs if there is package in cart and user was editing
          !this.isFetching ? this.AdditionalLogicOnActivityChange() : ""
           this.preFillDirtyData() //to detect changes for note,time and staff. prefill them
      },
      activePackageItem: function (newValue, oldValue) {
        //check if for each item change staff is selected or not
        if (this.schedulingPackage) {
          console.log(" i was called in activepackageitem watch", newValue);
          this.setActivePackageItemId();
        }
      },
      status: function (val, old) {
        if (val == "E") this.EditMode()
      },
      
    },
    methods: _.extend(vuex.mapMutations([]), {
      updActiveItemId: function(){
        var unbkdItemId = _.findKey(this.users[this.username], function(el){return el.ActivityName && !el.time});
        this.activeSpaItemId = unbkdItemId;
      },
      setaddNewOtbData: function(spaItemId, date, sameday){
        var vm = this;
        this.activeSpaItemId = spaItemId;
        if(!sameday){
          this.serviceDetails.date = date;
          this.serviceDetails.preferedDate = date;
        }
      },
      handleScroll: function () {
        window.scrollTo({
          top: document.body.scrollHeight + 10,
          left: 0,
          behavior: 'smooth'
        })
      },
      handleContinueClick: function(){ //this runs when clicked on "book button on conflicting package booking warning popup"
        this.rebookPackageItem()
      },
      setDetectedChangeBoolean: function(k,v) {
        vm =this
         var payload = { key: k,value: v} 
          vm.$store.commit('setDetectedChanges',payload)
      },
      stickyLogic: function () {
        var maxScoll = document.scrollingElement? document.scrollingElement.scrollHeight - document.documentElement.clientHeight : 0
        var reserve_btn_position = maxScoll - 10
        if (window.pageYOffset <= reserve_btn_position) {
          this.sticky_reserve_btn = true
        } else this.sticky_reserve_btn = false
        if (window.pageYOffset <= (document.scrollingElement? document.scrollingElement.scrollHeight - document.documentElement.clientHeight - 14:0)) {
          this.sticky_schedule_update_Btn = true;
        } else {
          this.sticky_schedule_update_Btn = false
        }
      },
      userServiceId: function () {
        return (
          this.activeUser +
          Object.keys(this.users[this.username])[this.currentlyEditingService]
        );
      },
      remove_time_choice: function () {
        var vm = this
        vm.$store.commit("SetselectedTimeOnTimePicker", ""); //uncheck selected time
        vm.$store.commit('setDetectedChanges',{'key':'time',value: false})  // to disable reserve button again
       
         _.each(this.AvailableStaffList,function(list,serviceId){
          var all_staffs_per_day = list
          _.each(all_staffs_per_day,function (a) { //
            a.show = true //when clicked to remove time from disabled staff 
          })
          setGenderAllow(serviceId)
          vm.AvailableStaffList[serviceId] = [].concat(all_staffs_per_day)
         })
        _.each(this.AvailableStaffList, function (list, serviceId) {
       
        })
       function setGenderAllow(serviceId){ 
            var GenderItem = JSON.parse(JSON.stringify(vm.Genders[serviceId]))
            GenderItem.forEach(function (gender, key) {
                gender.show = true
                delete gender.time
            })
            vm.Genders[serviceId] = GenderItem
          }
      },
      getConditionalServiceId: function (id) {
        // this is needed because of singlebookingmode where user can only book a one service at a time, so we dont need a unique id
        if (this.schedulingPackage) return id;
        else if (this.singleBookingMode) return id.split('-')[0]; //this
        else return id
      },
      filter_incompatible_staff: function () { //this is for filtering staff based on time selected
        var vm = this
        if(_.isEmpty(vm.AvailableStaffList)) return; //means no staff came back from Api so nothing to filter. Usually happens when there are no availabilities. 
        var time = ""
        if (!this.schedulingPackage) {
          var bookedStaff =  getBookedStaff(this.users[this.username][this.activeSpaItemId])
          var pickedDateTime = vm.dataForBookingService[this.activeSpaItemId.split('-')[0]].time
          time = moment(pickedDateTime, "YYYY-MM-DDHHmmss").format('hh:mm a');
          filter_compatibility(this.activeSpaItemId,pickedDateTime, time, vm,bookedStaff)
        } else {
          var package_items = this.users[this.username][this.activeSpaItemId]
          .package_item.PackageItems.PackageItem;
           package_items.forEach(function (item) {
          var bookedStaff =  getBookedStaff(item)
          var pickedDateTime = vm.dataForBookingService[item.SpaItemId].time
          time = moment(pickedDateTime, "YYYY-MM-DDHHmmss").format('hh:mm a');
          filter_compatibility(item.SpaItemId, pickedDateTime,time, vm,bookedStaff)
          })
        }
        function filter_compatibility(service_id, pickedDateTime,time, vm,bookedStaff) {
         
          // if(!vm.SpaAvailabilities.staff[active_service_id]) return;
          var active_service_id =  service_id.split('-')[0]
          var staffs_avail_per_time = vm.SpaAvailabilities.staff ? vm.SpaAvailabilities.staff[active_service_id][pickedDateTime] : [] //returns staffs able to perform service selected time
          var conditionalServiceId = vm.getConditionalServiceId(service_id)
          var all_staffs_per_day = vm.AvailableStaffList[conditionalServiceId]
          var genderFilter = {
              'M':0,
              'F':0
          }
          //handling case where booked time doesnt come back with staff list. Could be because that was the last staff or bug.

          if (_.isEmpty(staffs_avail_per_time)) { //means staff list for time and service didnt come back. In this case make all staff unavailable except booked.

            var time = moment(pickedDateTime, "YYYY-MM-DDHHmmss").format('hh:mm a');
            all_staffs_per_day.forEach(function (a) {

              if (a.id == bookedStaff.staffId && vm.bookedStaffShowLogic(time)) {
                a.show = true
              } else {
                a.show = false;
                a.time = time
              }
            })
             _.each(vm.Genders[active_service_id], function(gender){
                ['M','F'].indexOf(gender.prefix)>-1 && gender.prefix != bookedStaff.staffGender &&  vm.bookedStaffShowLogic(time) ?  setGenderAllow([gender.prefix], false, time) : ''
             })
          }
         else if (staffs_avail_per_time.length != all_staffs_per_day.length) { // means some staff not avail to perform on this time

            result = all_staffs_per_day.filter(function (a1) {
              return !staffs_avail_per_time.some(function (a2) {
                return a2.id == a1.id 
              })
            }) //list of staff not possible

            all_staffs_per_day.forEach(function (a) {
              if (result.map(function (e) {
                  return e.id
                }).indexOf(a.id) > -1 ) {
                if(a.id == bookedStaff.staffId && vm.bookedStaffShowLogic(time)){ // in edit mode, for booked time dont disable booked staff(auto/staffpicked))
                  a.show = true
                }
                else{
                a.show = false
                a.time = time
                }
              } else {
                a.show = true
                delete a.time
              }
              if(a.show == true){
                genderFilter[a.gender]++
              }
            })
          // it is possible that for a given time, gender related staff are not available so if all gender specific
            // staff are disabled then i also make gender "male or female" example 9 pm all female staff are avail
          _.each(genderFilter,function(key,gender){
            setGenderAllow([gender], key>0 ? true:false,time)
          })
          
          function isStaffAbleToPerform(staffInCombination,selectedTime,vm){
            var staffAvailableToPerfom = true;
           return vm.isServiceBooked &&vm.bookedStaffShowLogic(time) ||staffAvailableToPerfom
          // if(vm.isServiceBooked &&vm.bookedStaffShowLogic(pickedDateTime) )
          // }
          } 
          } else {
            all_staffs_per_day.forEach(function (a) {
              a.show = true
              delete a.time

              // if(a.show == true){
              //   genderFilter[a.gender]++
              // }
              setGenderAllow(['M','F'],true)
            })
         
          }
         
          vm.AvailableStaffList[conditionalServiceId] = [].concat(all_staffs_per_day)

          function setGenderAllow(arr, isPossible, unavailableTime) {
            var GenderItem = JSON.parse(JSON.stringify(vm.Genders[active_service_id]))
            GenderItem.forEach(function (gender, key) {
               
              if (arr.indexOf(gender.prefix) > -1 && !gender.notAvail) {
                gender.show = isPossible
                !isPossible && unavailableTime ? gender.time = unavailableTime : delete gender.time
              }
            })
            vm.Genders[active_service_id] = GenderItem
          }
        }
        function getBookedStaff(item){
          var obj = {}
          if ((['X', 'P','M','F'].indexOf(item.staffGenderOrId) <= -1)){
            obj.staffId = item.staffGenderOrId
          } else   obj.staffId = item.autoAssignedStaff       
          obj.staffGender = item.staffGender
            return obj
        }
      },
      editPackageItem: function (e) { //for editing individual package item
        this.$store.commit('setActivePackageItem', e.target.value)
        this.$store.commit("setStatus", 'E');
      },
      setDirtyData: function (itemId, key, value) { // detect changes like note,staff,time specially for editng purpose
       var payload = {};
        itemId = (this.schedulingPackage) ? itemId : itemId.split('-')[0]
        payload[itemId] = this.dataForBookingService[itemId] || {}
        payload[itemId][key] = value
        this.$store.commit("setdataForBookingService", payload)
      },
      addStaff: function (staff,staffName,staffGender, itemId,username,userClicked) {
      
        var vm = this
        var dfd2 = $.Deferred();
        vm.showStaffDropDown = false
        var targetedItemIndex = 0;
        var payload = {
          staff: staff,
          userId: username||vm.username,
          isPackage: vm.schedulingPackage,
          staffGenderOrId: staff,
          staffName:staffName,
          staffGender: staffGender
        };
         
        var activeService =vm.users[username][vm.schedulingPackage ? vm.activeSpaItemId:itemId]  //in case of package, each item's itemid is without time stamp, so need to use activeSpaItemId
       
        var previousAssignedStaff = !_.isEmpty(vm.autoAssignedStaffPerGuestInBookForAll[username])?Object.assign({}, vm.autoAssignedStaffPerGuestInBookForAll[username]): {staffId: activeService.staffGenderOrId,gender:activeService.staffGender}
        if(vm.schedulingPackage){
          payload.id = vm.activeSpaItemId;
          payload.packageItemId = itemId // these are without timestamp used for making id unique
        }    else payload.id = itemId // this is unique

     
  
     // logic to refetch avail on mount and when user select staff. On mount if user has already selected staffs or gender for more then one item, then donot send refetch call for all items.
      
       if( vm.schedulingPackage && ((!userClicked && itemId == vm.activePackageSpaItemId) || userClicked)) refetchPackageSpaAvail(vm,dfd2,staff,itemId,userClicked) //In this addstaff function 90% of the logic is to apply time filter per staff so this function runs on mount  for every item if they had chosen a staff for it. So itemid ==activePackageSpaItemId is added to make sure it doesnt refetch for every items on mount unless clicks
       else dfd2.resolve()
       dfd2.promise().then(function (data) { 

      //Below logic is recently added to accommodate clean Time issue. It involves refetching new availability when user clicks to change a staff. It then compare it with existing availability and filter those times per new availability while maintaining filters previously applied to other package items; since new avail has no record of previous filters for other items
      if( vm.schedulingPackage && data){
        var newAvailCombination = {} 
        _.each(data.data,function(combination,index){ 

          var item = combination[0]
            newAvailCombination[item.time] = combination // because we are fetching spa availability when user selects a staff, book order items may come different everytime so update the order of combination   
        })

        _.each(vm.SpaAvailabilities.data,function(obj){
           if(newAvailCombination[obj.StartDateTime] && obj.StartDateTime != vm.getActiveServiceBookedDateTime){// combination may change even if start time of package is same, replace it with new one. Donot replace currectly booked time when editing
           
            obj.combination = newAvailCombination[obj.StartDateTime] 
            obj.available = true
         // }
         // else{
            // if((['X','P'].indexOf(staff)>-1) && obj.showTime){ //it if possible that user picked a staff and then later decided to select no pref or "select staff" and with that selection ,filtered times may not come back due to result of  spa avail call  instead of staff filter. In that case dont show time. 
            //   obj.available = false
            // }
          } 
        })

          // updatedInfo in packageBookingInfo is an array which contains  booking details that will be passed to spa controller. Also storing refeched staff data for a selected date intoa  originalInfo to update staff  due to recent addition of staff booking concept  outside of combinations based staff, 
           vm.packageBookingInfo.originalInfo = newAvailCombination[vm.selectedDateTimeOnTimePicker]
          var clonedArray = JSON.parse(JSON.stringify(vm.packageBookingInfo.updatedInfo))
          if (vm.selectedDateTimeOnTimePicker && !vm.isServiceBooked  ) {
            _.each(clonedArray, function (booking, index) {
              _.some(newAvailCombination[vm.selectedDateTimeOnTimePicker], function (newCombination) {
         
                if (booking.SpaItemId == newCombination.itemid) {
                  booking['SpaStaffId'] = newCombination.staffId
                  booking['staffGender'] = newCombination.gender
                  booking['staffName'] = newCombination.staffName
                  booking['StartDateTime'] = newCombination.time
                  itemId == booking.SpaItemId?booking['staffGenderOrId'] =  staff: ''
                return;
                }
              })
            })
         
            vm.packageBookingInfo.updatedInfo = clonedArray
          }
      }
        
       //below is a logic to filter availabilty per day based on staff "vs" availability overall per day. Also to insert staffname or gender - start 
       var loc = vm.localStrings.stepper.body.schedule.dropdown
        var genders = obj = {
          "M": loc['male'].gender,
          "F": loc['female'].gender,
          "P": loc['noPreference'].gender,
          "X": loc['selectStaff'].gender,
        }
        var AvailabilityPerItem = vm.SpaAvailabilities['staff']? vm.SpaAvailabilities['staff'][itemId.split('-')[0]] : []
        var AvailabilityPerStaff = _.filter(Object.keys(AvailabilityPerItem), function (data) {
          return _.some(AvailabilityPerItem[data], function (val) {
            if (parseInt(staff)) {
              if (val.SpaStaffId == staff) return true
            } else return val.gender == staff
          })
        })

        //-end

      handleSelectedStaffNotAvailable()//this function is reposnible handling a case where selected staff doesnt come back from Api in two situations .1) user is booking for a first time 2) user is editing.  n case one user may change a date and selected staff may not be available. 2) in case of edit, booked staff doesnt come back next time user come to edit. In first case this function will auto unassign selected staff and remove filter. In second case, it will disable all time and to show booked staff name on hover which didnt come back from api, i am setting it from store
        function handleSelectedStaffNotAvailable() {

         if (vm.isServiceBooked) {
          vm.setDirtyData(itemId, 'staff', staff)
          vm.setDirtyData(itemId, 'staffName', payload.staffName)
          vm.setDirtyData(itemId, 'staffGender', payload.staffGender)
          filter_incompatible_time(payload.staffName )
         } else {
           if (_.isEmpty(AvailabilityPerStaff) && ['X', 'P'].indexOf(staff) <= -1) { //unassign and dont filter 
             payload.staffGenderOrId = "X" //
             payload.staffName = genders[payload.staffGenderOrId]
             vm.setIsFetchingFalse() 
              setTimeout(function () {
               vm.$store.commit('setshowLoaderOnStaffChange', false);
            }, 400);
           } else filter_incompatible_time(staffName)
           vm.$store.commit("setStaff", payload)
         }

       }
       bookForAllStaffLogic(previousAssignedStaff,vm)

       function bookForAllStaffLogic(previousAssignedStaff,vm){
              //when booking for all is enabled(booking for all at same time), disable this staff for other guests to prevent picking same staff
        if(vm.bookForAllGuestCheckBox){
          var staffList = vm.AvailableStaffList[itemId.split('-')[0]]
          var userServiceObj= vm.users[username][itemId]

          //case user picked gender then disable auto assinged staff for rest of other guests and also keep trakc of that auto assinged staff so later used in booking
         
          if (['M', 'F'].indexOf(staff) > -1) {
         
            var staffForSelectedTime = vm.AvailableStaffList[itemId.split('-')[0]]
            var staffArr = staffForSelectedTime;
            staffArr = staffForSelectedTime.filter(function (staffObj) {
              return _.values(vm.alreadyAssignedStaff).indexOf(staffObj.id) == -1 || vm.alreadyAssignedStaff[username] == staffObj.id
            });
            staffArr.some(function (staffObj) {
             
              if (staffObj.gender == staff && staffObj.show == true) {
                vm.autoAssignedStaffPerGuestInBookForAll[username] = {
                  staffId: staffObj.id,
                  staffName: staffObj.name,
                  gender: staffObj.gender,
                }
                vm.alreadyAssignedStaff[username] = staffObj.id; // to not reuse for autoassigning 
        
                return true;
              }
              return false;
            });
          }
          //CASE :  USER PICKED STAFF
          _.each(staffList, function (staffMember) {
            var autoStaffObj = vm.alreadyAssignedStaff[username]
            if (['M', 'F'].indexOf(staff) > -1) {
   
              if (autoStaffObj == staffMember.id) staffMember.availableForOtherGuest = false //
              if (previousAssignedStaff.staffId == staffMember.id && autoStaffObj != previousAssignedStaff.staffId) delete staffMember.availableForOtherGuest
            } else if (['X', 'P'].indexOf(staff) > -1) {
              if (staffMember.id == vm.alreadyAssignedStaff[username]) {
                delete staffMember.availableForOtherGuest
                vm.alreadyAssignedStaff[username] = {}
              }
            } else {
              var d = previousAssignedStaff
              if (!isNaN(staffMember.id) && staffMember.id == d.staffId && d.staffId != staff && userClicked) {
                delete staffMember.availableForOtherGuest
              }
              if (!isNaN(staffMember.id) && staffMember.id == staff) {
                staffMember.availableForOtherGuest = false // disable choice for other staff
                vm.alreadyAssignedStaff[username] = staffMember.id; // to not reuse for autoassigning 
               vm.alreadyAssignedStaff[username] = staffMember.id; // to not reuse for autoassigning 
                vm.alreadyAssignedStaff[username] = staffMember.id; // to not reuse for autoassigning 
                vm.autoAssignedStaffPerGuestInBookForAll[username] = {}
              }
             

            }
          
          })
            //CASE 2: IT MAY HAPPEN THAT THERE ARE ONLY TWO STAFFS AVAILABLE. IF GUEST ONE PICKS ONE THEN ALONG WITH DISABLING THAT STAFF FOR SECOND GUEST, DO ALSO DISABLE GENDER IF THESE TWO STAFFS WERE OF OPPOSITE GENDER.
             
            var genderList = JSON.parse(JSON.stringify(vm.Genders[itemId.split('-')[0]]));
           
            _.each(genderList, function (gender) {
         
              if (['M', 'F'].indexOf(gender.prefix) > -1) {
                if (payload.staffGender == gender.prefix && gender.prefix != previousAssignedStaff.gender) gender.remainingStaffCount--;
                if (gender.prefix == previousAssignedStaff.gender && payload.staffGender != gender.prefix) gender.remainingStaffCount++;

                if (gender.remainingStaffCount < 1)
                  gender.availableForOtherGuest = false
                else 
                  delete gender.availableForOtherGuest
              } else {
              
                if (staff == gender.prefix && staff != previousAssignedStaff.staffId) {
                  vm.autoAssignedStaffPerGuestInBookForAll[username] = {}
                  vm.alreadyAssignedStaff[username] = {}
                  gender.remainingStaffCount++;
                }
              }
            })
            vm.Genders[itemId.split('-')[0]] = genderList

          vm.AvailableStaffList[itemId.split('-')[0]] =JSON.parse(JSON.stringify(staffList))
        }
       }

        //below logic for filtering times based on staff selected
        function filter_incompatible_time(staffName) { //this is for filtering incompatible time based on staff selected
          var clonedSpaAvailabilities = _.extend({}, vm.SpaAvailabilities)
          var noPref = vm.localStrings.sideCart.service.body.noPreferenceText
          var selectStaff = vm.localStrings.sideCart.service.body.selectStaff
          var bookedStaff = ""
          if (vm.schedulingPackage) {

            if(vm.isServiceBooked){
              var packageItems = vm.users[vm.username][vm.activeSpaItemId].package_item
            .PackageItems.PackageItem;
            _.each(packageItems,function(item){
              if(item.staffGenderOrId == staff) bookedStaff = item.staffGenderOrId
            })
            } 
            _.each(clonedSpaAvailabilities.data, function (avail, index) {
              targetedItemIndex = _.findIndex(avail.combination, function (d) {
                return d.itemid == itemId
              })
            if(avail.combination[targetedItemIndex]){
              if (['X','P'].indexOf(staff) > -1  ) { //"reason for bookedStaff is that if user is in the edit mode and user clicks other staff and then clicks back a booked staff again then if it were to disable times, prevent disabling the booked time" because  staff is already booked for booked time
                avail.combination[targetedItemIndex].isTimePossible = true
                avail.combination[targetedItemIndex].disabledStaff = ""
              } else{
                if ((AvailabilityPerStaff.indexOf(((avail.combination[targetedItemIndex]).time)) <= -1) && !vm.bookedTimeShowLogic(avail.startTime)) {
                  avail.combination[targetedItemIndex].isTimePossible = false
                  avail.combination[targetedItemIndex].disabledStaff = staffName
                } else {
                  avail.combination[targetedItemIndex].isTimePossible = true
                  avail.combination[targetedItemIndex].disabledStaff = ""
                }
              }
              avail.showTime = avail.combination.length == (function (n) {
                var i = 0;
                n.forEach(function (val) {
                  val.isTimePossible ? i++ : ""
                })
                return i;
              })(avail.combination)
               }
           // }
          })
          
        } else {
           if(vm.isServiceBooked){
              var service = vm.users[vm.username][vm.activeSpaItemId]
              if(service.staffGenderOrId == staff) bookedStaff = service.staffGenderOrId
            }
            _.each(clonedSpaAvailabilities.data, function (availability, index) {
              extraLogicForBookingAllGuest(availability) //if checked
              var usernameAndServiceId = username + '_' + itemId
              
              if (['X','P'].indexOf(staff)>-1 ) {
                availability.isTimePossible[usernameAndServiceId] = true
                delete availability.unavailableStaff[usernameAndServiceId]
              } else {
                if ((AvailabilityPerStaff.indexOf((availability.StartDateTime)) <= -1)  && !vm.bookedTimeShowLogic(availability.startTime)  ) {
                  availability.isTimePossible[usernameAndServiceId] = false
                  availability.unavailableStaff[usernameAndServiceId] = staffName // saving staff per user in case of doing book for all
                } else {
                  availability.isTimePossible[usernameAndServiceId] = true
                  delete availability.unavailableStaff[usernameAndServiceId]
                }
              }
              availability.showTime = Object.keys(availability.isTimePossible).length == (function (n) {
                var i = 0;
                _.each(n, function (val) {
                  val ? i++ : ""
                })
                return i;
              })(availability.isTimePossible)
            })

            function extraLogicForBookingAllGuest(availability) {
              //when booking for all guest for same time, then instead of clearing objects in availability state, keep adding for each user(time possible to book, (if user not picked a staff for which time is not pissble then add its name))
              if (vm.bookForAllGuestCheckBox) { // keep modifying existing objects below so that if one user changes staff, it retail changes to following below
                availability.isTimePossible = availability.isTimePossible || {}
                availability.unavailableStaff = availability.unavailableStaff || {}
              } else { // unchecked means booking one by one and so in that case clear previous filters applied if any to these objects. That is, availability properties are effected only by one user 
                availability.isTimePossible = {}
                availability.unavailableStaff = {}
              }
              availability.showTime = true
            }
          }
          vm.setIsFetchingFalse() // this logic is moved from being called right after new availability comes to here if it fetches new avail again for staff
            setTimeout(function () {
           vm.$store.commit('setshowLoaderOnStaffChange', false);
        }, 800);
        
          vm.SpaAvailabilities = _.extend({}, clonedSpaAvailabilities)
        }
       })
      
        function refetchPackageSpaAvail(vm,dfd2,staff,itemId,userClicked){
          vm.$store.commit('setshowLoaderOnStaffChange', true);
          vm.$store.commit("setStatus",vm.localStrings.stepper.body.schedule.status.staffChangeMsg)
           if (vm.schedulingPackage) {
              var dfd = $.Deferred();
              if (!!helpers.promiseRef) { //wait for store to set before executing further
                helpers.promiseRef.then(function () {
                  dfd.resolve();
                  helpers.promiseRef = null;
                });
              } else dfd.resolve();
              var activeUserServiceData = vm.users[vm.username][vm.activeSpaItemId]
              var selectedServiceDuration = activeUserServiceData.ServiceTime
              var packageTemp = activeUserServiceData.package_item;
              var pkgItemsArr = packageTemp.PackageItems.PackageItem;
              var packageStaffObj = {}
              if(!vm.isServiceBooked){
              _.each(pkgItemsArr,function(pkgItem){ 
                packageStaffObj[pkgItem.SpaItemId] = pkgItem.SpaItemId == itemId ?staff:pkgItem.staffGenderOrId
              })
              }
              else{
                _.each(vm.dataForBookingService,function(pkgItem,key){ 
       
                packageStaffObj[key] = key == itemId ?staff:pkgItem.staff
              })
              }

              var MaxMinsBetweenBookings = packageTemp.MaxMinsBetweenBookings;
              bookedTime = packageTemp.PackageItems.PackageItem[vm.activePackageItem].dateTime;
              dfd.promise().then(function () {    
                helpers.fetchPackageAvailabilities(
                    dateTime,
                    pkgItemsArr,
                    MaxMinsBetweenBookings,
                     false,
                    vm.currentUserId, null, null, 2, packageTemp.MinMinsBetweenBookings,packageStaffObj,false,vm.isServiceBooked
                  )
                  .then(function (data) {
                      dfd2.resolve(data)
                  }).fail(function (err) {
                      dfd2.resolve()
                  })
              })
            }
        }

      },
      bookedStaffShowLogic: function(time,id) {
        
          var vm = this
          var bookedTime = vm.getActiveBookedTime
          var bookConditionOne = vm.isServiceBooked && vm.selectedTimeOnTimePicker == bookedTime && vm.selectedDateOnDateBar == vm.getActiveServiceFormattedDate
         //booked time in case of packae is usually the package starting time. When this function runs against othe rpackge package time it will return false and will also disable booked staff for other item. so we handle it.
         if(vm.isServiceBooked){
           return vm.schedulingPackage? bookConditionOne : bookConditionOne &&  bookedTime == time
         } else return false
      },
        bookedTimeShowLogic: function(time,id) {
        
          var vm = this
          var bookedTime = vm.getActiveBookedTime
         //booked time in case of package is usually the package starting time. When this function runs against othe rpackge package time it will return false and will also disable booked staff for other item. so we handle it.
        
           return vm.isServiceBooked && vm.selectedTimeOnTimePicker == bookedTime && bookedTime == time && vm.selectedDateOnDateBar == vm.getActiveServiceFormattedDate
      },
      addNotes: function (e, itemId,username) {
        var vm = this
        var payload = {
          note: e.target.value,
          userId: username|| vm.username, //when booking for all, addNote runs for each user and vm.username is only for first active user so "username" contains username for each guest making changes to note or staff
          isPackage: vm.schedulingPackage,
        }
        if (vm.schedulingPackage) {
          payload.id = vm.activeSpaItemId; //ids with timestamp
          payload.packageItemId = itemId // these are without timestap which is used for making an id unique
          //In case of package booking, each "time" on the UI consists of a lot of info about package and its items. They are store in "time" to efficiently perform a various checks on them based on staff or booked time and to use info later. So every time user clicks on a time, addPackageItemInStorage function is called, which creates an object that is being passed to the spa controller.If user clicks on the time first then update the guest note, we need to update the existing object created above.
          if (vm.selectedDateTimeOnTimePicker && !vm.isServiceBooked) {
            var clonedArray = JSON.parse(JSON.stringify(vm.packageBookingInfo.updatedInfo))
            _.each(clonedArray, function (booking, index) {
              if (booking.SpaItemId == itemId) booking['guestNote'] = e.target.value
            })
            vm.packageBookingInfo.updatedInfo = clonedArray
          }
            
        } else payload.id = itemId
       !this.isServiceBooked? this.$store.commit("setNote", payload):vm.setDirtyData(itemId, 'note', e.target.value)
        
      },
      
      addPackageItemInStorage: function (payload) { 
        vm = this;
        var targetedItemIndex = 0;
        var package_items = vm.users[vm.username][vm.activeSpaItemId].package_item.PackageItems.PackageItem   
        vm.packageBookingInfo.updatedInfo = [].concat(_.map(payload, function (items) {
          targetedItemIndex = _.findIndex(package_items, function (item) {
              return item.SpaItemId == items.itemid
          })
          var data = {
            SpaItemId: items.itemid,
            StartDateTime: items.time,
            SpaStaffId: items.staffId,
            guestNote: vm.getActiveUserNote(items.itemid),
            duration: items.duration,
            name: items.name,
            staffGenderOrId : package_items[targetedItemIndex]['staffGenderOrId'],
            staffName: items.staffName,
            staffGender: items.gender
          }
          return data
        }))
        
      },
      EditMode: function () {
        this.$store.commit("setbookingButtonText", this.localStrings.stepper.body.schedule.bookingButtonText.update)
 
       
        if (this.schedulingPackage) {
          vm = this;
          var packageItems = this.users[this.username][this.activeSpaItemId].package_item
            .PackageItems.PackageItem;
          var index = packageItems.findIndex(function (obj) {
            // index of currently editing item
            return obj.SpaItemId == vm.activePackageSpaItemId;
          });
  
          var newArr = index > 0 ? packageItems.slice(0, index) : []
          var remain = index > 0 ? packageItems.slice(index) : [] // 
          console.log("new arr", newArr);
          console.log("remail", remain);
          var history = newArr.map(function (obj) {
            return {
              time: obj.dateTime,
              itemid: obj.SpaItemId,
              duration: obj.ServiceTime,
              ItemName: obj.ItemName,
              SpaFolioItemId: obj.SpaFolioItemId
            };
          });
          console.log("history", history);
          console.log("reservedtime", this.reservedTimesForUser)
          //in case user select other service to edit then if user previously selected package for editing then we need to put back history items back to reserved times 
         // this.AddHiddenPackageItemsToReserved()
          var obj = {}
          obj[vm.currentUserId] = packageItems
          //vm.$store.commit('AddHiddenReservedTime', obj)
          remain.forEach(function (obj) {
            vm.$store.commit('removeReservedTime', {
              FolioItemId: obj.SpaFolioItemId,
              id: obj.SpaItemId,
              userId: vm.currentUserId
            })
          })
          if (history.length <= 0) this.fetchAvailability();
          else this.fetchAvailability(history);
        } else {
          this.fetchAvailability() //fetch -> apply filters(staff,time book for all) if any
        }
      },
      addDate: function (date) {
        // check if date is already selected
        if(this.lastFetchDate && this.lastFetchDate == date) return;
        var payload = {
          preferedDate: date,
          id: this.activeSpaItemId,
          userId: this.username
        };
         this.$store.commit("setselectedDateOnDateBar",date)
        if (!!this.activeSpaItemId) this.$store.commit("setPreferedDate", payload);
        this.fetchAvailability("",date)
      },
      addBookingTime: function (time) {
        var payload = {
          time: moment(time, "YYYY-MM-DDHHmmss").format("hh:mm a"),
          id: this.activeSpaItemId,
          name: this.username,
          isPackage: this.schedulingPackage
        };
        this.$store.commit("setBookingTime", payload);
      },
      createIntervals: function (start, end) {
        var startTime = moment(start, "HH:mm");
        var endTime = moment(end, "HH:mm");
        if (endTime.isBefore(startTime)) {
          endTime.add(1, "day");
        }
        var timeStops = [];
        while (startTime <= endTime) {
          timeStops.push(new moment(startTime).format("HH:mm"));
          startTime.add(15, "minutes");
        }
        return timeStops;
      },
      bookService: function (e) {
        var activeServiceId = this.activeSpaItemId.split('-')[0]
       //clearing changes detected if exist and review page content if booked any
        this.$store.commit('setReviewScreenBookingDetails',{})
        if ( !this.conditionsToBookorEdit || this.forceGenderSelect) {
          
          if(this.forceGenderSelect) this.$store.commit("setErrorMessage",this.localStrings.stepper.body.schedule.errors.selectStaffFirst)

          else if(!this.conditionsToBookorEdit ) this.$store.commit("setErrorMessage",this.localStrings.stepper.body.schedule.errors.pickTime)


          !this.desktopMode ? window.scrollTo({
            top: 376,
            behavior: 'smooth'
          }) : null
           vm.$store.commit('SetbookFromCart',false)//incase triggerd from sidecart
        } else { 
          if (this.schedulingPackage) this.bookPackageService();
          else this.bookSingleService();
        }
         vm.$store.commit('SetbookFromCart',false) //for resetting reserve button on side cart. Reserve button on side card calls bookservice from this file and to detect the click there is watch for above
      },
      bookSingleService: function () {
        var oldStatus = this.$store.state.status;
        var vm = this
        var bookingOnDifferentDay= false
        var userServices = this.getActiveServiceDetails //if booking for all then it returns services object for each otherwise for activeuser
        var booking_payload_per_user = []
       // this.alreadyAssignedStaff = []
        _.each(userServices,function(service,key){
          var staffSelectionData = vm.getActiveUserStaff(service.SpaItemId,service.username);
          var payload = {
            guestNote: vm.getActiveUserNote(service.SpaItemId,service.username),
            itemId: service.SpaItemId,
            SpaFolioItemId: vm.getActiveServiceFolioId(service.SpaItemId,service.username) || "",
            staffId: staffSelectionData.staffId,
            CustomerId: service.username,
            username: vm.usersWithIds[service.username],
            staffGenderOrId : staffSelectionData.staffGenderOrId,
            staffName: staffSelectionData.staffName,
            staffGender: staffSelectionData.staffGender
          }
      payload.dateTime =vm.dataForBookingService[vm.activeSpaItemId.split('-')[0]].time || vm.getActiveServiceBookedDateTime //in case if user has not 

      // When updating a package/service, if time has changed then all those items that are affected by it will have their existing time/staff cleared first before rebooking. For optimization purposes, if it is a new date then don't clear the booking  
      if(vm.getActiveServiceFormattedDate != vm.selectedDateOnDateBar) bookingOnDifferentDay = true
      payload['bookingOnDifferentDay'] =bookingOnDifferentDay

			booking_payload_per_user.push(payload)//when booking one by one or all together , this contains payload for all guests or single guest booking same service
        })
       // console.log("926",booking_payload_per_user)
       console.log('maka',booking_payload_per_user)
        app.controllers.spaController.bookSpaPackage(booking_payload_per_user, 0,'', oldStatus).then(function(){ helpers.updateNavBar(); });
      },
      bookPackageService: function () {
        if (!this.users[this.username][this.activeSpaItemId].SpaFolioItemId) {
          var payload = {
            dateTime: this.dataForBookingService[this.activePackageSpaItemId].time, //just to get datetime for first item
            CustomerId: this.username,
            itemId: this.activeSpaItemId,
            bookingItems: this.packageBookingInfo.updatedInfo
          }
          
          app.controllers.spaController.bookSpaPackage(payload, 1).then(function(){ helpers.updateNavBar(); });
        } else {
          this.getConflictingPackageItem()
        }
      },
      getConflictingPackageItem: function () {
        //  function checks if new times picked for package item is conflicting with existing timings or not(edit modd) ifonly if time is changed otherwise just rebook 
        var existingCombination = this.users[this.username][this.activeSpaItemId]
          .package_item.PackageItems.PackageItem;
        var vm = this;
        var conflicting = []

        var CustomerId = this.username
        if(this.detectedChanges.time){ //then popup stuff happen
             var newCombination = this.packageBookingInfo.updatedInfo
                 conflicting = newCombination.filter(function (o) {
                   return !existingCombination.some(function (v) {
                    if (v.SpaItemId == o.SpaItemId && v.dateTime == o.StartDateTime ) {
                   return true;
                    }
                  if (v.SpaItemId == o.SpaItemId) {
                  o.SpaFolioItemId = v.SpaFolioItemId
                  o.time = moment(o.StartDateTime, "YYYY-MM-DDHHmmss").format("hh:mm a")
                  o.oldTime = moment(v.dateTime, "YYYY-MM-DDHHmmss").format("hh:mm a")
                  o.CustomerId = CustomerId
                  var dirtyData = vm.dataForBookingService[v.SpaItemId]
                  if (dirtyData.note != o.guestNote || dirtyData.staff !=  o.staffGenderOrId){
                    var staffSelectionData = vm.getActiveUserStaff(v.SpaItemId, null, v.dateTime); // already check dirty data for staff
     
                    o.staffGenderOrId= staffSelectionData.staffGenderOrId,
                    o.staffName= staffSelectionData.staffName,
                    o.staffGender= staffSelectionData.staffGender,
                    o.SpaStaffId = staffSelectionData.staffId
                    o.guestNote = dirtyData.note
                    }
                }
                 return false;
            });
          })
  
          if(conflicting.length){
             this.packageBookingInfo.updatedInfo = conflicting
             this.$refs.package_item_conflict_popup.show()
          }
        }
        else { //this is kind of replica of "addPackageItemInStorage" function but this need some tweaks and conditions so rewriting it here 
          var vm = this
          _.map(existingCombination, function (items) {
            var dirtyData = vm.dataForBookingService[items.SpaItemId]
            if (dirtyData.note != items.note || dirtyData.staff != items.staffGenderOrId) {
              var staffSelectionData = vm.getActiveUserStaff(items.SpaItemId, null, items.dateTime);
              var data = {
                SpaItemId: items.SpaItemId,
                StartDateTime: items.dateTime,
                SpaStaffId: staffSelectionData.staffId,
                guestNote: dirtyData.note,
                duration: items.ServiceTime,
                name: items.ItemName,
                SpaFolioItemId: items.SpaFolioItemId,
                staffGenderOrId: staffSelectionData.staffGenderOrId,
                staffName: staffSelectionData.staffName,
                staffGender: staffSelectionData.staffGender,
                CustomerId:CustomerId
              }
 
              conflicting.push(data)
              return data
            }
          })
          vm.packageBookingInfo.updatedInfo = conflicting
          vm.rebookPackageItem()
        }
         
      },
      rebookPackageItem: function () {
        vm = this
        var bookingOnDifferentDay = false
        vm.$store.commit('setShowLoaderForBooking', true);
        var payload = {
          itemId: vm.activeSpaItemId,
          CustomerId: vm.username,
          dateTime: this.dataForBookingService[vm.activePackageSpaItemId].time || vm.getActiveServiceBookedDateTime,
          bookingItems: vm.packageBookingInfo.updatedInfo
        }
        // When updating a package, if time has changed then all those items that are affected by it will have their existing time/staff cleared first before rebooking. For optimization purposes, if it is a new date then don't clear the booking
        if(vm.getActiveServiceFormattedDate != vm.selectedDateOnDateBar) bookingOnDifferentDay = true
        payload['bookingOnDifferentDay'] =bookingOnDifferentDay
        app.controllers.spaController.bookSpaPackage(
          payload, 1, 1).then(function(){ helpers.updateNavBar(); });

      },
     
      setActivePackageItemId: function () {
        this.activePackageSpaItemId = this.users[this.username][
          this.activeSpaItemId
        ].package_item.PackageItems.PackageItem[
          this.activePackageItem
        ].SpaItemId;
      },
      updateCalender: function (availSpa) {
        var vm = this;
        helpers.fetchFutureBookingsForUser(this.currentUserId).always(function (futureSpaBookings) {
          var events = [];
          futureSpaBookings.forEach(function (booking) {
            vm.$store.commit("addReservedTime", {
              data: booking,
              id: vm.currentUserId
            });
          });
          vm.reservedTimesForUser.forEach(function (bk) {
            var moreDetailsPerItem = vm.users[vm.username][bk.SpaItemId]
            var obj = {
              start: moment(bk.StartTime, "YYYY-MM-DDHHmmss").format(
                "YYYY-MM-DD HH:mm"
              ),
              end: moment(bk.EndTime, "YYYY-MM-DDHHmmss").format(
                "YYYY-MM-DD HH:mm"
              ),
              title: bk.activity,
              status: "booked",
              class: bk.isFutureBooking ? "leisure" : "sport",
              content: '<i class="v-icon material-icons">shopping_cart</i>',
              date:moreDetailsPerItem? moreDetailsPerItem.date:"",
              time:moreDetailsPerItem? moreDetailsPerItem.time:"",
              note:moreDetailsPerItem?moreDetailsPerItem.note:"",
              staffName:moreDetailsPerItem? moreDetailsPerItem.staffName:"",
              staffId:moreDetailsPerItem? moreDetailsPerItem.staffGenderOrId:"",
              user:vm.username
            };
            events.push(obj);
          });
          vm.$store.commit("setUserCalenderEvents", events);
        });
      },
      checkCanBookAllGuestIsSetAlready: function (obj) {
        var vm = this;
        if (app.customization.spaBooking.alwaysShowSameTimeforallGuests && vm.bookForAllGuestCheckBox && 
            vm.SpaAvailabilities && vm.SpaAvailabilities.data &&  vm.SpaAvailabilities.data.length > 0 ) {
          var checkStatus =  _.find(vm.SpaAvailabilities.data, function (spaAvailableData) { 
            return (spaAvailableData.StartDateTime.indexOf(obj.StartDateTime) > -1)
          });
          return checkStatus ? checkStatus.canBookAllGuest :false;
        } else {
          return true;
        }
      },
      // methods to handle currently editing item
      FilteredSpaAvailAndStaff: function (availSpa) {
        if (!availSpa.data) return vm.$store.commit("setIsFetching", false);
        var list = [];
        vm = this
        var displayOrderCount = {};
        console.log("availSpa", availSpa)
        var availTimes = Object.keys(availSpa.data);
        availSpa.data.forEach(function (service,index) {
          //availability check and filter
          if (vm.schedulingPackage  ) {
            vm.setActivePackageItemId();
                 var item = service[0] //use a first item in the combination to show their possible times on the screen and store remaining items'in it.
                  var obj = { // when putting dummy time, some of field might be undefined
                    StartDateTime: item.time,// startdatetime when dummy time needed
                    duration: item.duration,
                   // SpaItemId: vm.activePackageSpaItemId,//
                    SpaItemId: item.itemid,//
                    startTime: moment(item.time, "YYYY-MM-DDHHmmss").format('hh:mm a'),
                    activity: item.name,
                    combination: [].concat(service),
                    showTime:true,
                    available:true
                  };
                  list.push(obj);
                  return true;
          } else {
           var obj = {
              StartDateTime: service.StartDateTime,
              startTime: service.startTime
          };
            //logic get number of avail staff per time only in case of booking single service per multiple guests
           
            var numOfStaffPerTime = ((availSpa.staff[vm.activeSpaItemId.split('-')[0]]||{})[service.StartDateTime]) || []
            obj.numOfStaffPerTime = numOfStaffPerTime.length
            /* 
              previous to this change , the below line was overwritten with true for all times, even it didnt have spa same time available for all guests, 
              so added new method (checkCanBookAllGuestIsSetAlready) to get same value from method FilterAvailabilityPerGuests
            */
            obj.canBookAllGuest = vm.checkCanBookAllGuestIsSetAlready(obj) // old comment : this is true to initialize; as user clicks on book for all then fiilter will occur
            obj.showTime = true //this changes based on staff availability
            list.push(obj);
          }
        })
      
        var temp = {};

        //logic to filter staff avail per service
        if (vm.schedulingPackage) {
          var package_items = this.users[this.username][this.activeSpaItemId].package_item.PackageItems.PackageItem
          package_items.forEach(function (item) {
            var staffs = availSpa.staff && availSpa.staff[item.SpaItemId] && availSpa.staff[item.SpaItemId].allStaff || {}
            var item_capable_staff = [].concat(item.CapableStaff.Staff)
            var genderFilter = {
            'M': 0,
            'F':0
            }
             //it is possible that In edit mode, booked staff doesnt come back.In this case, compare all staffs available if it has booked id in it, if not then put the dummy
            if(vm.isServiceBooked){
              var bookedStaff =  item.autoAssignedStaff || item.staffGenderOrId
              if(!isNaN(bookedStaff) && !staffs[bookedStaff]){
              staffs[bookedStaff] = true
           }
          }
            temp[item.SpaItemId] = _.chain(item_capable_staff).filter(function (val) {
              val.show = true
               if(staffs[val.id]) genderFilter[val.gender]++
              return staffs[val.id]
            }, staffs).sortBy('name').value()
            FilterIncompatibleGender(genderFilter,item.SpaItemId)
          })
        } else {
          var itemId = this.activeSpaItemId ? this.activeSpaItemId.split('-')[0] : null
          var staffs = availSpa.staff && availSpa.staff[itemId] && availSpa.staff[itemId].allStaff || {}
          var item_capable_staff = [].concat(this.users[this.username][this.activeSpaItemId].CapableStaff)
        
        //if in single mode then dont use unique key for available staff list because we could book same service for multiple user and so stafflist should be same for both
        var conditionalServiceId = this.getConditionalServiceId(this.activeSpaItemId)
        var genderFilter = {
            'M': 0,
            'F':0
        }

        //it is possible that In edit mode, booked staff doesnt come back.In this case, compare all staffs available if it has booked id in it, if not then put the dummy
        if(vm.isServiceBooked){
          var singleService=vm.users[vm.username][vm.activeSpaItemId]
          var bookedStaff = singleService.autoAssignedStaff|| singleService.staffGenderOrId
          if(!isNaN(bookedStaff) && !staffs[bookedStaff]){
            staffs[bookedStaff] = true
          }
        }
        temp[conditionalServiceId] = _.chain(item_capable_staff).filter(function (val) {
          val.show = true

          if(staffs[val.id]) genderFilter[val.gender]++ //this is for filtering a gender.It is possible
          // that for a given service, only gender related staff are available. In that case disable other gender selection
          return staffs[val.id]
        }, staffs).sortBy('name').value()
        //if gender filter then disable other gender from drop down
        FilterIncompatibleGender(genderFilter,vm.activeSpaItemId.split('-')[0])
        }
        function FilterIncompatibleGender(genderFilter,itemId){
          var genderList = JSON.parse(JSON.stringify(vm.Genders[itemId]));
          _.each(genderList,function(gender){
          
            if(['M','F'].indexOf(gender.prefix)> -1) {
              if(genderFilter[gender.prefix] == 0){
                gender.show = false
                gender.notAvail = true
              }
              // this field is only for "book for all guest mode". If there are 2 males left and there are three guests then descrement male count after selecting male for each guest so that third guest wont get it. In book for all mode , stafflist is shared
              gender.remainingStaffCount = genderFilter[gender.prefix]  
            }
          })
          vm.Genders[itemId] = genderList
        }
        //end
        console.log("temp", temp)
        console.log("gender",vm.Genders)
        vm.AvailableStaffList = _.extend({}, temp);
        vm.SpaAvailabilities = _.extend({}, {
          data: list,
          staff:  availSpa.staff || {},
          rooms: availSpa.rooms || {},
          equipment:availSpa.equipment || {}
        })
         vm.$store.commit("setErrorMessage",!vm.SpaAvailabilities.data.length ? vm.localStrings.stepper.body.schedule.errors.staff.all.noAvailability:"")
        
        vm.ApplyStaffAndFilterLogic() // methods to handle currently editing item
      }, 

      setIsFetchingFalse: function(){
        var vm = this
        setTimeout(function () {
          vm.$store.commit("setIsFetching", false);
        }, 600);
      },
      AdditionalLogicOnActivityChange: function () {
         //when booking in the queue(multiple users per service and booking them one by one), if service is not booked then fetch availability based on the selected date of previously booked service in the queue. it is a guarantee that the selected date of previously service is available since the function that set selected for the first service runs on a mount and this function only runs when changing user or service
       if (this.isServiceBooked) this.EditMode() 
      },
      getActiveUserNote: function (itemId,username) {
        var vm = this

        if (vm.schedulingPackage) {
          var targetedItemIndex = 0;
          var package_items = vm.users[vm.username][vm.activeSpaItemId].package_item.PackageItems.PackageItem
          targetedItemIndex = _.findIndex(package_items, function (item) {
            return item.SpaItemId == itemId
          })
          return vm.isServiceBooked ? vm.dataForBookingService[itemId].note : package_items[targetedItemIndex]['note']
        } else return vm.isServiceBooked ? vm.dataForBookingService[itemId.split('-')[0]].note : vm.users[username][itemId]['note']
      },
        getActiveUserStaff: function (itemId, username, packageItemTime) { 
      
          var vm = this;
          var staffGenderOrId;
          var staffId, staffName, staffGender;
          var detectedStaff = ''
          var staffDetails = {}
          var dateTime = packageItemTime ? packageItemTime : this.dataForBookingService[itemId.split('-')[0]].time;
          // var itemId = vm.schedulingPackage? itemId : itemId.split('-')[0]
          if (vm.schedulingPackage) {
            var targetedItemIndex = 0;
            var package_items = vm.users[vm.username][vm.activeSpaItemId].package_item.PackageItems.PackageItem
            targetedItemIndex = _.findIndex(package_items, function (item) {
              return item.SpaItemId == itemId
            })
            detectedStaff = vm.isServiceBooked ? vm.dataForBookingService[itemId].staff : package_items[targetedItemIndex]['staffGenderOrId']
            staffId = detectedStaff
            staffGenderOrId = detectedStaff
            staffGender =vm.isServiceBooked ? vm.dataForBookingService[itemId].staffGender: package_items[targetedItemIndex]['staffGender']
          } else {
            staffId = vm.isServiceBooked ? vm.dataForBookingService[itemId.split('-')[0]].staff : vm.users[username][itemId]['staffGenderOrId']
            detectedStaff = staffId
            staffGenderOrId = detectedStaff
            staffGender = vm.isServiceBooked ? vm.dataForBookingService[itemId.split('-')[0]].staffGender: vm.users[username][itemId]['staffGender']
          }
          if (isNaN(staffId)) { //its a gender
            if (this.SpaAvailabilities.staff && this.SpaAvailabilities.staff[itemId.split('-')[0]][dateTime]) {
              if (vm.schedulingPackage) {


                if(vm.selectedDateTimeOnTimePicker != vm.getActiveServiceBookedDateTime){
                var packageDataFromHelpers = _.find(vm.SpaAvailabilities.data, function (avail) {
                  return avail.StartDateTime == vm.selectedDateTimeOnTimePicker
                });
                staffDetails = _.find(packageDataFromHelpers.combination, function (pi) {
                  return pi.itemid == itemId
                });
                }
                else{
                  _.each(vm.packageBookingInfo.originalInfo,function(staff){
                    if(staff.itemid == itemId){
                      staffDetails.staffId = staff.staffId
                      staffDetails.staffName = staff.staffName
                      staffDetails.gender = staff.gender
                    }
                  })
                }
                if (!_.isEmpty(staffDetails)) {

                  staffId = staffDetails.staffId;
                  staffName = staffDetails.staffName;
                  staffGender = staffDetails.gender
                } else handleNoStaffReturn(vm) //tihis usually happens when service is booked and user is editing it. staff for booked time may not come back 

              } else {
                var staffForSelectedTime = this.AvailableStaffList[itemId.split('-')[0]]
                var staffArr = staffForSelectedTime;
                
  
                if (vm.bookForAllGuestCheckBox) {
                  // staffArr = staffForSelectedTime.filter(function (staff) {
                  //   return vm.alreadyAssignedStaff.indexOf(staff.id) == -1;
                  // });
                  staffArr = staffForSelectedTime.filter(function (staffObj) {
                    return _.values(vm.alreadyAssignedStaff).indexOf(staffObj.id) == -1 
                  });

                }
                if (['M', 'F'].indexOf(staffId) == -1) { //gender is x or p
                
                  _.each(staffArr,function(staff){
                    if(staff.show == true) {// means it is possible
                      staffId = staff.id;
                      staffName = staff.name;
                      staffGender = staff.gender
                    }
                  })
                    if (vm.bookForAllGuestCheckBox) {
                     vm.alreadyAssignedStaff[username] = staffId // staffGenderOrId is the staff id. 
                    }
                } else {
                         //Incase of book for all mode, the logic check(only M and F) for getting auto assigned staff details was moved to addStaff() to accommodate recent requirment: When book for all mode is on, if One guest chooses male for example then to disable the auto assigned staff for other guests above check was moved to addStaff() . Since getActiveUserStaff() runs before user clicks a book button, it is important to return autoAssigned staff that was calculated in addStaff() function which is in autoAssignedStaffPerGuestInBookForAll
                    if(vm.bookForAllGuestCheckBox){
           
                      var staffInfoForGuest = vm.autoAssignedStaffPerGuestInBookForAll[username]
                        staffId = staffInfoForGuest.staffId;
                        staffName = staffInfoForGuest.staffName;
                        staffGender = staffInfoForGuest.gender
                    }
                    else{
                      staffArr.some(function (staff) {
                        if (staff.gender == staffId && staff.show == true ) {
                          staffId = staff.id;
                          staffName = staff.name;
                          staffGender = staff.gender
                          return true;
                        }
                        return false;
                      });
                    }
           
                }
              }
            } else  handleNoStaffReturn(vm) 

            function handleNoStaffReturn(vm) {
              var staffArr = vm.AvailableStaffList[itemId.split('-')[0]] //this is to access a dummy staff/existing staff; available Staff is filled with dummy staff if fetch spa fails to return anything or doesnt return booked staff or 
              if (['M', 'F'].indexOf(staffId) == -1) { //gender is x or p
                 _.each(staffArr,function(staff){
                    if(staff.show == true) {// means it is possible
                      staffId = staff.id;
                      staffName = staff.name;
                      staffGender = staff.gender
                    }
                  })
              } else {
                staffArr.some(function (staff) {
                  if (staff.gender == staffId) {
                    staffId = staff.id;
                    staffName = staff.name;
                    staffGender = staff.gender
                  }
                });
              }
            }
          }
        
          return {
            staffId: staffId,
            staffGenderOrId: staffGenderOrId,
            staffName: staffName,
            staffGender: staffGender
          };
        },
      getActiveServiceBookingDetails: function () {
        var service =  this.users[this.username][this.activeSpaItemId]
        if(this.schedulingPackage) return service.package_item.PackageItems.PackageItem[this.activePackageItem]
        else return service.bookingDetails
      },
      getActiveServiceFolioId: function (SpaItemId,username) {
        return this.users[username][SpaItemId].SpaFolioItemId;
      }, 
      getActiveServiceOfAllGuests:function(){ //runs when checkbox for all guest is on
         var activeServiceId = this.activeSpaItemId.split('-')[0]
         var arr = []
                  _.each(vm.users, function (user,userKey) {
                    _.each(user,function(item,itemKey){
                      if(item.service && item.service.SpaItemId == activeServiceId && !item.SpaFolioItemId){
                        item.username = userKey // to differentiate same service for each user
                        item.SpaItemId = itemKey
                        arr.push(item)
                      }
                    })
                  })
        return arr; //this returns active service objects for each user
      },
      getStatus: function () {
        return this.$store.state.status;
      },

      ApplyStaffAndFilterLogic:function(ischeckedBookForAll) {
        var vm = this
        var userservices = this.getActiveServiceDetails
        //if (!this.users[this.username][this.activeServiceID].SpaFolioItemId) {
          if (this.schedulingPackage) { //in single booking mode package is booked in serial fashion so we use details of currently actice service and user like this.username or activeSpaItemId
            var package_items = this.users[this.username][this.activeSpaItemId]
              .package_item.PackageItems.PackageItem
            package_items.forEach(function (item) {
              if ( ['X','P'].indexOf(item.staffGenderOrId || vm.dataForBookingService[item.SpaItemId].staff) <= -1 ) { // when changing date, if in edit mode then look for staff in detected change as it is not saved in store until clicked update
                if(vm.isServiceBooked){
                  var changedData = vm.dataForBookingService[item.SpaItemId] 
                    vm.addStaff(changedData.staff,changedData.staffName,changedData.staffGender, item.SpaItemId,vm.username,false)
                } else{
                    vm.addStaff(item.staffGenderOrId,item.staffName,item.staffGender, item.SpaItemId,vm.username,false)
                }  
              } else vm.setIsFetchingFalse()
            })
          } else {
            _.each(userservices,function(service){
               if (['X','P'].indexOf(service.staffGenderOrId) <= -1 || ischeckedBookForAll==false) { //ischeckedbookforall exists when a person clicks to uncheck the"book for all guest checkbox" to now apply staff logic only for active user
                vm.addStaff(service.staffGenderOrId,service.staffName,service.staffGender, service.SpaItemId, service.username)
              } else vm.setIsFetchingFalse()
            })
              
          }
       // }
      },

      fetchAvailability: function (history,userPickedDate) {
          var membershipIds = app.data.membershipDetails && app.data.membershipDetails.membershipItemIds || [];
          var vipLevels = app.data.membershipDetails && app.data.membershipDetails.VIPLevels || [];
          app.commonViewHelper.eval_ttb({module:"spaBooking", date: userPickedDate, item: this.users[this.username][this.activeSpaItemId], vipLevel: vipLevels, membershipId:membershipIds});

          var vm = this;
          var activeUserServiceData = vm.users[vm.username][vm.activeSpaItemId] || {};
          activeUserServiceData.service.SpaFolioItemId = this.serviceDetails.SpaFolioItemId;
          var selectedServiceDuration = activeUserServiceData.ServiceTime
          var selectedDate = userPickedDate || vm.getActiveServiceFormattedDate
          var selectedStaff = activeUserServiceData.staff;
          var bookedDate = ""

          vm.$store.commit("setLastFetchDate", selectedDate);
          
          if (!!selectedDate) {
            // selectedDate = moment(
            //   selectedDate,
            //   "MMMM D, YYYY"
            // ).format("YYYY-MM-DD");
            this.$store.commit("setIsFetching", true);
            dateTime = moment((selectedDate + "000000"), "YYYY-MM-DDHHmmss").format(
              "YYYY-MM-DDHHmmss");
            if (this.schedulingPackage) {
              var dfd = $.Deferred();

              if (!!helpers.promiseRef) { //wait for store to set before executing further
                helpers.promiseRef.then(function () {
                  dfd.resolve();
                  helpers.promiseRef = null;
                });
              } else dfd.resolve();

              var packageTemp = activeUserServiceData.package_item;
              var pkgItemsArr = packageTemp.PackageItems.PackageItem;
               var packageStaffObj = {}
              _.each(pkgItemsArr,function(pkgItem){
                packageStaffObj[pkgItem.SpaItemId] ="X"
              })
              var MaxMinsBetweenBookings = packageTemp.MaxMinsBetweenBookings;
              bookedTime = packageTemp.PackageItems.PackageItem[this.activePackageItem].dateTime;
              dfd.promise().then(function () {
                helpers.fetchPackageAvailabilities(
                    dateTime,
                    pkgItemsArr,
                    MaxMinsBetweenBookings,
                    history ? history : false,
                    vm.currentUserId, null, null, 2, packageTemp.MinMinsBetweenBookings,packageStaffObj,!!activeUserServiceData.SpaFolioItemId
                  )
                  .then(function (data) {
                    console.log("package availability with/without history", JSON.parse(JSON.stringify(data)));
                    if (!data.data.length) {
                      return handleNoAvailability(vm)
                    }
                    else{
                      vm.$store.commit("setNoAvails", false);
                      HandleNoBookedTimeReturn(vm,data)
                    }
                   // vm.FilteredSpaAvailAndStaff(data)
                    vm.$store.commit("setErrorMessage", "")
                  }).fail(function (err) {
                    handleNoAvailability(vm)
                  })
              })
            } else {
              vm = this
              helpers
                .fetchSpaAvailabilities(
                  this.activeSpaItemId.split("-")[0],
                  dateTime,
                  selectedServiceDuration,
                  selectedStaff,
                  activeUserServiceData.service,
                  this.currentUserId,
                  this.activeSpaItemId,
                  this.isServiceBooked || this.bookingProgressPerUser > 1 || (this.OTBactive && this.firstTimeOtbBook)
                )
                .then(function (data) {
                  console.log("spa avail for single service fetch", data)
                  if (data.data.length) {
                    // Dynamic restriction code for spaPreventBookingDateRanges
                    if(app.customization.dynamicRestrictions && app.commonViewHelper.active_ttb_effects.spaPreventBookingDayTimes){
                        var spaPreventBookingDayResult = app.commonViewHelper.groupEffects(app.commonViewHelper.active_ttb_effects.spaPreventBookingDayTimes);
                        if(spaPreventBookingDayResult.isActive && spaPreventBookingDayResult.value && spaPreventBookingDayResult.value.length){
                          _.each(spaPreventBookingDayResult.value, function(timePeriod){
                            data.data = _.filter(data.data, function(item){
                              var itemDate = moment(item.StartDateTime.substr(0,10)).format('YYYY-MM-DD');
                              var startTime = moment(itemDate + ' ' + timePeriod.startTime, 'YYYY-MM-DD h:mma');
                              var endTime = moment(itemDate + ' ' + timePeriod.endTime, 'YYYY-MM-DD h:mma');
                              var itemTime = moment(itemDate + ' ' + item.startTime, 'YYYY-MM-DD h:mma');
                              return !(itemTime.isSameOrAfter(startTime) && itemTime.isSameOrBefore(endTime));
                            });                   
                          })
                        }
                    }
                    vm.$store.commit("setNoAvails", false);
                    HandleNoBookedTimeReturn(vm,data)// if availability comes back but doesnt have a booked time in it, it is responsible for accurately putting dummy rime
                  } else {
                    handleNoAvailability(vm)
                  }

                }).fail(function (err) {
                  handleNoAvailability(vm)
                })
            } 
          }
        function HandleNoBookedTimeReturn(vm,data) {
          if (vm.users[vm.username][vm.activeSpaItemId].SpaFolioItemId) {
            var serviceBookedTime = moment(vm.getActiveServiceBookedDateTime, "YYYY-MM-DDHHmmss")
            var bookedDateTime = vm.getActiveServiceBookedDateTime
            var bookedTimeReturned = isBookedTimeExist(data, bookedDateTime,vm) //check if booked time came back from api
            if (!bookedTimeReturned && vm.getActiveServiceFormattedDate == vm.selectedDateOnDateBar) { // we want make sure that selected date on calender is the one user booked service on and then check if time came back from api or not
             var timeObj = getDummyTimeObj(vm)
             var timeObjPos = {
               positionFound: false,
               index:0,
               EndOfArray: false
             }
              data.data.some(function (times, index) {
                var availTime = ''
                if (vm.schedulingPackage) {
                  availTime = moment(times[0].time, "YYYY-MM-DDHHmmss")
                  timeObj[0].time == times[0].time ?  data.data.splice(index, 1):''
                } else availTime = moment(times.StartDateTime, "YYYY-MM-DDHHmmss")
                // means booked time didnt come back in fetch api call so  need to put dummy time  
                if (!availTime.isBefore(serviceBookedTime )&& !timeObjPos.positionFound ) {
                    timeObjPos.positionFound = true
                    timeObjPos.index = index
                } else if (availTime.isBefore(serviceBookedTime) && data.data.length - 1 == index  && !timeObjPos.positionFound ) { //reached end of the list
                  timeObjPos.positionFound = true
                  timeObjPos.EndOfArray = true
                }
                return false;
              })
              !timeObjPos.EndOfArray?  data.data.splice(timeObjPos.index, 0, timeObj):data.data.push(timeObj)
               
              function getDummyTimeObj(vm) {
                var service = vm.users[vm.username][vm.activeSpaItemId]
                var data = []
                if (vm.schedulingPackage) {
                  var package_item = service.package_item.PackageItems.PackageItem

                  _.each(package_item, function (item) {
                    obj = {
                      time: item.dateTime,
                      // itemid: vm.activePackageSpaItemId,
                      itemid: item.SpaItemId,
                      isTimePossible: true,
                      staffId: item.autoAssignedStaff || item.staffGenderOrId,
                      name: item.ItemName,
                      staffName: item.autoAssignedStaffName || item.staffName,
                      gender: item.staffGender,
                      duration: item.ServiceTime
                    }
                    data.push(obj)
                  })
                  return data
                } else {
                  obj = {
                    startTime: moment(service.bookingDetails.StartDateTime, "YYYY-MM-DDHHmmss").format("hh:mm a"),
                    StartDateTime: service.bookingDetails.StartDateTime,
                    canBookAllGuest: true,
                     SpaStaffId: service.bookingDetails.SpaStaffId,
                  } 
                  return obj
                }
              }
            }
          }
          vm.FillGenderPerService() //refresh gender list on each new avail on mount
          vm.FilteredSpaAvailAndStaff(data)
        }
          function getDummyTimeObj(vm) {
                var service = vm.users[vm.username][vm.activeSpaItemId]
                var data = []
                if (vm.schedulingPackage) {
                  var package_item = service.package_item.PackageItems.PackageItem
     
                  _.each(package_item, function (item) {
                    obj = {
                      time: item.dateTime,
                      itemid: item.SpaItemId,
                      isTimePossible: true,
                      staffId: item.autoAssignedStaff || item.staffGenderOrId,
                      name: item.ItemName,
                      staffName: item.autoAssignedStaffName || item.staffName,
                      gender: item.staffGender,
                      duration: item.ServiceTime,
                      showTime: true,
                    }
                    data.push(obj)
                  })
                  return data
                } else {
                  obj = {
                    startTime: moment(service.bookingDetails.StartDateTime, "YYYY-MM-DDHHmmss").format("hh:mm a"),
                    StartDateTime: service.bookingDetails.StartDateTime,
                    SpaStaffId: service.bookingDetails.SpaStaffId,
                    canBookAllGuest: true,
                    showTime: true,
                  }
                  return obj
                }
              }
        function handleNoAvailability(vm) {
          vm.$store.commit("setIsFetching", false);
          vm.$store.commit("setNoAvails", true);
          var service = vm.users[vm.username][vm.activeSpaItemId]
          if (vm.isServiceBooked &&  vm.getActiveServiceFormattedDate == vm.selectedDateOnDateBar) { 
            var existingTimeObj = getDummyTimeObj(vm)
            var tempArr = []
            !_.isArray(existingTimeObj)? tempArr.push(existingTimeObj): tempArr.concat(existingTimeObj)
            vm.SpaAvailabilities = _.extend({}, {
              data: tempArr,
            })
            //logic for adding existing time -end
            //logic for adding existing staff dummy if applicable -s
            var service = vm.users[vm.username][vm.activeSpaItemId]
              if(vm.schedulingPackage){
                var package_items = service.package_item.PackageItems.PackageItem
                _.each(package_items,function(item){
                  addDummyStaff(item,vm)
                })
                }else{
                  var singleService  = vm.users[vm.username][vm.activeSpaItemId]
                  addDummyStaff(singleService,vm)
                }
          } else  vm.SpaAvailabilities = _.extend({}, {data: [] })
          return;
        }
          function addDummyStaff(item, vm) {
            var obj = {}
            var itemId = vm.getConditionalServiceId(item.SpaItemId)
            obj[itemId] = [].concat({
              show: true,
              gender: item.staffGender
            })
            if ((['X', 'P','M','F'].indexOf(item.staffGenderOrId) <= -1)){
        
               obj[itemId][0].id = item.staffGenderOrId
                obj[itemId][0].name =item.staffName
               }
            else {
              obj[itemId][0].id = item.autoAssignedStaff
              obj[itemId][0].name =item.autoAssignedStaffName
            }
            vm.AvailableStaffList = _.extend({}, obj)
          }
            function isBookedTimeExist(data, bookedTime, vm) {
              var exists = false
              data.data.some(function (times, index) {
              
                if (vm.schedulingPackage) {
                  var targetedItemIndex = _.findIndex(times, function (item) {
                    return item.itemid == vm.activePackageSpaItemId
                  })

                  if (times[targetedItemIndex].time == bookedTime) exists = true
                } else {
                  if (times.StartDateTime == bookedTime) exists = true
                }

              })

              return exists
            }
      },
      //helper function

      AddHiddenPackageItemsToReserved: function () {
        var vm = this
        if (Object.keys(vm.HiddenReservedPackageItems).length > 0) {
          var userID = Object.keys(vm.HiddenReservedPackageItems)[0]
          vm.HiddenReservedPackageItems[userID].forEach(function (item) {
            var payload = {
              data: {
                StartTime: item.dateTime,
                EndTime: moment(item.dateTime, 'YYYY-MM-DDHHmmss').add(item.ServiceTime, 'minutes').format('YYYY-MM-DDHHmmss'),
                activity: item.ItemName,
                SpaItemId: item.SpaItemId,
                isFutureBooking: false,
                SpaFolioItemId: item.SpaFolioItemId
              },
              id: userID
            }
            vm.$store.commit("addReservedTime", payload);
          //  vm.$store.commit('AddHiddenReservedTime', {})
          })
        }
      },
      preFillDirtyData: function(){
          var vm = this
           vm.$store.commit('setdataForBookingService',{}) //reset dirty data itself
           vm.$store.commit('setDetectedChanges',{}) //reset changes status
          if( vm.username && vm.activeSpaItemId ){ //prefill only if currently active service is booked
            if(vm.schedulingPackage){
              var package_items = vm.users[vm.username][vm.activeSpaItemId].package_item.PackageItems.PackageItem
              _.each(package_items,function(item){
                vm.setDirtyData(item.SpaItemId, 'note', item.note)
                vm.setDirtyData(item.SpaItemId, 'staff', item.staffGenderOrId)
                vm.setDirtyData(item.SpaItemId, 'time', item.dateTime)
                vm.setDirtyData(item.SpaItemId, 'staffName', item.staffName)
                vm.setDirtyData(item.SpaItemId, 'staffGender', item.staffGender)
              })
            }
            else{
              var singleActiveService = vm.users[vm.username][vm.activeSpaItemId]
                vm.setDirtyData(vm.activeSpaItemId, 'note', singleActiveService.note)
                vm.setDirtyData(vm.activeSpaItemId, 'staff',singleActiveService.staffGenderOrId)
                vm.setDirtyData(vm.activeSpaItemId, 'time', singleActiveService.bookingDetails.StartDateTime)
                vm.setDirtyData(vm.activeSpaItemId, 'staffName', singleActiveService.staffName)
                vm.setDirtyData(vm.activeSpaItemId, 'staffGender', singleActiveService.staffGender)

            }
          } 
      },
      FillGenderPerService:function(){ //packages cannot share same gender objects so im using gender per service/item
        var vm = this
        var genders = [
       
        {
          name: "No Preference",
          prefix: "P",
          show:true,
          notAvail:false
        },
        {
          name: "male",
          prefix: "M",
          show:true,
          notAvail:false
        }, {
          name: "female",
          prefix: "F",
          show:true,
          notAvail:false
        }]
        if(vm.username && vm.activeSpaItemId){
          if(vm.schedulingPackage){
             var package_items = vm.users[vm.username][vm.activeSpaItemId].package_item.PackageItems.PackageItem
             _.each(package_items,function(item){
                vm.Genders[item.SpaItemId] = genders
             })
          }
          else{ //single service. we will use non unique item id because if booking for all then they share same staff list and genders
           var nonUniqueServiceId = vm.activeSpaItemId.split('-')[0]
           vm.Genders[nonUniqueServiceId] = genders
          }
        }
      }
    }),
    components: {
      "date-time-selection": DateTimeSelection,
      popup: popup,
      scrollbar: vue_scrollbar,
      timepicker: timePicker,
      'schedule-btn': schedulebtn,
      'service-pref':servicePref,
      'booking-indicator':bookingIndicator,
      'grp-member-otb':GroupMembersOtb
    },
    beforeMount: function () {
      console.log("i was called before mount")
      var vm = this;
      this.$store.commit("setbookingButtonText", this.localStrings.stepper.body.schedule.bookingButtonText.buttonText[this.activeStep])
      _.keys(this.users).some(function (user, userIndex) {
        return _.keys(vm.users[user]).some(function (itemId, itemIndex) {
          if (!vm.users[user][itemId].SpaFolioItemId) {
            vm.$store.commit('changeActiveService', {
              user: userIndex,
              id: itemIndex
            })
            return true;
          }
         else if (vm.users[user][itemId].SpaFolioItemId == vm.editingFolioItemId) {
            vm.$store.commit('changeActiveService', {
              user: userIndex,
              id: itemIndex
            })
            return true;
          }
          return false;
        });
       })
      this.currentUser = this.activeUser;
      // this.username = Object.keys(this.users)[this.currentUser];

      //test.find(function(el){ return el.split("-")[0] == '1203'})
      if(this.OTBactive && (this.$store.state.status != 'E')){
        var userKeyIds = Object.keys(this.users[this.username]);
        this.activeSpaItemId = _.find(userKeyIds.reverse(), function(el){ return el.split("-")[0] == vm.service.SpaItemId})
        console.log('911', this.activeSpaItemId)
      }else{
        this.activeSpaItemId = Object.keys(this.users[this.username])[
        this.currentlyEditingService
      ];
      }
      if ((this.users[this.username][this.activeSpaItemId]||{}).package_item) {
        this.$store.commit("setActivePackageItem", 0);
        this.setActivePackageItemId();
        this.schedulingPackage = true;
        this.userList = Object.keys(this.users);
      }
      this.FillGenderPerService() //go to defination for more into
      this.AdditionalLogicOnActivityChange() //to fetch avail


        //this.$store.commit("setBookForAllGuestCheckBox", false)
        this.$store.commit("setErrorMessage","")
        this.preFillDirtyData() //to detect changes for note,time and staff  and prefill them
        //update sidcart calender( reason of doing it in mount is because user could remove service and so it should reflect rightaway on calender)
        helpers.updateCalender()
        
      
        
    },
    mounted: function () {
      window.addEventListener('scroll', this.stickyLogic);
      var vm = this;
      var serviceExists = _.keys(this.users).some(function(userName){
        if(_.keys(vm.users[userName]).length > 0) return true;
        return false;
      });
      if(!serviceExists) this.$store.commit('setActiveStep',0);
         window.scrollTo({
          top: 0,
          left: 0,
          behavior: 'smooth'
        })

        if(this.OTBactive) this.togglePref = this.forceGenderSelect;
    }
   
  }
});
})('<div :class="{\'noShowSched\' : editingFolioItemId && status != \'E\' && OTBactive}"> <booking-indicator v-if="!!loggedInUser && desktopMode" v-bind:is_service_booked="isServiceBooked"></booking-indicator> <popup ref="package_item_conflict_popup" v-show="packageBookingInfo.updatedInfo" :showBook="true" @handle-Continue-Click="handleContinueClick" > <template v-slot:header> <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> {{localStrings.stepper.body.schedule.warning}} </template> <template v-slot:booking> <!-- <button @click="rebookPackageItem()" class="btn btn-primary">Book anyway</button> --> </template> <template v-slot:body> <ul> <h4 class="package_item_conflict_popup_header">{{localStrings.stepper.body.schedule.status.packageRebookingWarning}}</h4> <p v-if="selectedDateOnDateBar != getActiveServiceFormattedDate"><strong>{{localStrings.stepper.body.schedule.conflictingBookingPopup.label}}</strong> {{localStrings.stepper.body.schedule.conflictingBookingPopup.from}}<strong>{{getActiveServiceFormattedDate}}</strong> {{localStrings.stepper.body.schedule.conflictingBookingPopup.to}} <strong>{{selectedDateOnDateBar}}</strong></p> <li name="body" v-for="(item,key) in packageBookingInfo.updatedInfo" :key="key">{{item.name}} <label>{{localStrings.stepper.body.schedule.conflictingBookingPopup.from}} </label> <strong>{{item.oldTime}}</strong> <label> {{localStrings.stepper.body.schedule.conflictingBookingPopup.to}} </label><strong>{{item.time}}</strong></li> </ul> </template> </popup> <p v-if="errorMessage && desktopMode" style="margin:auto;margin-bottom:20px" class="error alert-error .control-group.error">{{this.errorMessage}}</p> <p v-if="dynamicRestriction_timePickerErrorMessage" style="margin:auto;margin-bottom:20px" class="error alert-error" v-html="dynamicRestriction_timePickerErrorMessage" ></p> <div v-if="OTBactive && (this.$store.state.status != \'E\')" class=\'spb-pref\'> <h1 @click="togglePref = !togglePref"><span>{{localStrings.stepper.body.schedule.otb.servPrefLabel}}<i v-if="!togglePref" class="fas fa-angle-left"></i><i v-if="togglePref" class="fas fa-angle-down"></i></span></h1> <service-pref v-show="togglePref && !noAvails" v-bind:getActiveServiceDetails="getActiveServiceDetails" v-bind:schedulingPackage="schedulingPackage" v-bind:showStaffDropDown="showStaffDropDown" v-bind:service_booked_time="getActiveBookedTime" v-bind:addStaff="addStaff" v-bind:genders="genders" v-bind:otherGenders="Genders" v-bind:AvailableStaffList="AvailableStaffList" v-bind:remove_time_choice="remove_time_choice" v-bind:addNotes="addNotes" v-bind:isServiceBooked="isServiceBooked" @add-date="addDate" v-bind:alreadyAssignedStaff="alreadyAssignedStaff" :username="username" :service="service" @set_add_new_otbData="setaddNewOtbData" :getActiveServiceFormattedDate="getActiveServiceFormattedDate" > </service-pref> </div> <div class="main-body-schedule" :class="servicePrefConfig?\'main-body-schedule-reposition\':null"> <div class="main-body-first-section" ref="myref"> <div class="mobile_packageitem_edit_select" v-if="showMobileEditPackageItemBox"> <label for="">{{localization.spaBooking.packageBooking.mobile.editDescription}}</label> <select @change="editPackageItem($event)"> <option v-for="(item,index) in packageItems" :key="index" :value="index">{{item.ItemName}}</option> </select></div> <div class=\'spb-details\' v-if="OTBactive && (this.$store.state.status != \'E\')"> <div class="service-time-picker-div"> <slot name="hh"></slot> <h1 v-show="desktopMode"><span>{{localStrings.stepper.body.schedule.heading.pickDate}} </span></h1> <slot name="users"></slot> <date-time-selection v-on:add-date="addDate" v-bind:list="userList" v-bind:spa="SpaAvailabilities" v-bind:scheduling_package="schedulingPackage" v-bind:bookedOrPreferredDate="getActiveServiceFormattedDate" v-bind:active_package_item="activePackageItem" v-bind:isServiceBooked="isServiceBooked" v-bind:global_status="globalStatus" :itemArr=\'getActiveServiceDetails\' > </date-time-selection> </div> </div> <div v-else> <div class="service-time-picker-div"> <slot name="hh"></slot> <h1 v-show="desktopMode"><span>{{localStrings.stepper.body.schedule.heading.pickDate}} </span></h1> <slot name="users"></slot> <date-time-selection v-on:add-date="addDate" v-bind:list="userList" v-bind:spa="SpaAvailabilities" v-bind:scheduling_package="schedulingPackage" v-bind:bookedOrPreferredDate="getActiveServiceFormattedDate" v-bind:active_package_item="activePackageItem" v-bind:isServiceBooked="isServiceBooked" v-bind:global_status="globalStatus" :itemArr=\'getActiveServiceDetails\' > </date-time-selection> </div> <service-pref v-if="desktopMode && !noAvails" v-bind:getActiveServiceDetails="getActiveServiceDetails" v-bind:schedulingPackage="schedulingPackage" v-bind:showStaffDropDown="showStaffDropDown" v-bind:service_booked_time="getActiveBookedTime" v-bind:addStaff="addStaff" v-bind:genders="genders" v-bind:otherGenders="Genders" v-bind:AvailableStaffList="AvailableStaffList" v-bind:remove_time_choice="remove_time_choice" v-bind:addNotes="addNotes" v-bind:isServiceBooked="isServiceBooked" @add-date="addDate" v-bind:alreadyAssignedStaff="alreadyAssignedStaff" :username="username" > </service-pref> </div> </div> <timepicker v-bind:service="service" v-bind:spa_avail_times="checkDayIsDisabled ? [] : SpaAvailabilities" v-bind:scheduling_package="schedulingPackage" v-bind:service_booked_time="getActiveBookedTime" v-bind:service_booked_date="getActiveServiceFormattedDate" v-bind:error_message="errorMessage" v-bind:isServiceBooked="isServiceBooked" v-bind:activeServiceBookedDateTime="getActiveServiceBookedDateTime" v-bind:active_service_item_id="activeSpaItemId||null" :username="username" :apply_staff_and_filter_logic="ApplyStaffAndFilterLogic" :remove_time_choice="remove_time_choice" @set-dirty-data="setDirtyData" @set_add_new_otbData="setaddNewOtbData" :set_active_packageItemId="setActivePackageItemId" @add-staff="addStaff" @upd-active-id="updActiveItemId" @add-PackageItem-In-Storage="addPackageItemInStorage" @filter-incompatible-staff="filter_incompatible_staff"> </timepicker> <div class="global-booking-info" v-if="!desktopMode"> <schedule-btn v-bind:is_service_booked="isServiceBooked" v-if="activeStep ==1 "></schedule-btn> </div> <service-pref v-if="!desktopMode && !noAvails" v-bind:getActiveServiceDetails="getActiveServiceDetails" v-bind:schedulingPackage="schedulingPackage" v-bind:showStaffDropDown="showStaffDropDown" v-bind:service_booked_time="getActiveBookedTime" v-bind:addStaff="addStaff" v-bind:genders="genders" v-bind:otherGenders="Genders" v-bind:AvailableStaffList="AvailableStaffList" v-bind:remove_time_choice="remove_time_choice" v-bind:addNotes="addNotes" v-bind:isServiceBooked="isServiceBooked" @add-date="addDate" v-bind:alreadyAssignedStaff="alreadyAssignedStaff" :username="username" > </service-pref> </div> </div>');
